import formatDateToISO8601 from '@/lib/utils/formatDateToISO8601'

export const filterPriceRanges = [
  { min: 0, max: 100, label: 'Até R$100' },
  {
    min: 100,
    max: 200,
    label: 'De R$100 a R$200',
  },
  {
    min: 200,
    max: 300,
    label: 'De R$200 a R$300',
  },
  {
    min: 300,
    max: Infinity,
    label: 'Acima de R$300',
  },
]

export const filterGiftsByPriceRange = (gifts, range) => {
  if (!range) return gifts
  return gifts.filter((gift) => {
    const amount = gift.valor_final || gift.valor
    const price = parseInt(amount)
    return price >= range.min && price <= range.max
  })
}

export const filterGiftsByCategories = (gifts, categories) => {
  if (!categories.length) return gifts
  return gifts.filter(
    (gift) => !!categories.find((category) => category.id === gift.id_categoria)
  )
}

export const filterRemoveAlreadyAddedGiftsFromCatalog = (
  giftsList,
  giftsCatalog
) => {
  if (!giftsList.length) return giftsCatalog

  return giftsCatalog.filter(
    (giftCatalog) =>
      !giftsList.find((gift) => gift.id_presente_sys === giftCatalog.id)
  )
}

const isBiggerThan = (giftA, giftB) => {
  const priceA = giftA.valor_final || giftA.valor || giftA.value
  const priceB = giftB.valor_final || giftB.valor || giftB.value
  return parseFloat(priceA) > parseFloat(priceB)
}

export const sortGifts = (gifts, order) => {
  switch (order) {
    case 'last':
      gifts.sort(
        (a, b) =>
          new Date(formatDateToISO8601(b.created_at_utc)).getTime() -
          new Date(formatDateToISO8601(a.created_at_utc)).getTime()
      )
      break
    case 'big':
      gifts.sort((a, b) => (isBiggerThan(a, b) ? -1 : 1))
      break
    case 'small':
      gifts.sort((a, b) => (isBiggerThan(a, b) ? 1 : -1))
      break
    case 'az':
    default:
      gifts.sort((a, b) => (a.nome > b.nome ? 1 : -1))
      break
  }
  return gifts
}

export const groupGiftsByCategories = (gifts) => {
  const sequenceCategories = [
    'Cama, mesa e banho',
    'Cozinha',
    'Decoração',
    'Eletrodomésticos',
    'Eletrônicos',
    'Móveis',
    'Outros',
    'Contribuição',
    'Divertidos',
    'Lua de mel e experiências',
  ]

  const indexByCategory = {}
  sequenceCategories.forEach((category, index) => {
    indexByCategory[category] = index
  })

  gifts.sort((a, b) => {
    const indexA = indexByCategory[a.categoria]
    const indexB = indexByCategory[b.categoria]
    return indexA - indexB
  })
  return gifts
}
